export const PopoutSvg = () => (
    <svg width="100%" height="100%" viewBox="0 0 197 155" fill="none" xmlns="http://www.w3.org/2000/svg"
         preserveAspectRatio="xMidYMid meet" focusable="false">
        <rect x="0.5" y="0.5" width="196" height="154" fill="#F9F9F9" stroke="#BDC1C6"></rect>
        <rect x="102.5" y="35.5" width="66" height="91" fill="white" stroke="#BDC1C6"></rect>
        <rect x="102.5" y="105.5" width="66" height="21" fill="white" stroke="#BDC1C6"></rect>
        <rect x="106.5" y="110.5" width="58" height="11" rx="5.5" fill="#F1F3F4" stroke="#BDC1C6"></rect>
        <g opacity="0.8" clip-path="url(#clip0_1607_177366)">
            <path
                d="M154.5 119V113L162 116L154.5 119ZM155.25 117.885L159.979 116L155.25 114.115V115.25L157.5 116L155.25 116.75V117.885ZM155.25 117.885V116V114.115V115.25V116.75V117.885Z"
                fill="#444746"></path>
        </g>
        <rect x="106" y="92" width="37" height="9" rx="2" fill="#D3E3FD"></rect>
        <rect x="106" y="55" width="47" height="16" rx="2" fill="#D3E3FD"></rect>
        <rect x="123" y="74" width="41" height="15" rx="2" fill="#DADCE0"></rect>
        <path d="M102.5 34C102.5 33.1716 103.172 32.5 104 32.5H167C167.828 32.5 168.5 33.1716 168.5 34V45.5H102.5V34Z"
              fill="#4285F4" stroke="#BDC1C6"></path>
        <circle cx="178" cy="136" r="9" fill="#4285F4"></circle>
        <g clip-path="url(#clip1_1607_177366)">
            <path
                d="M175.638 139L175 138.362L177.363 136L175 133.637L175.638 133L178 135.362L180.363 133L181 133.637L178.638 136L181 138.362L180.363 139L178 136.637L175.638 139Z"
                fill="white"></path>
        </g>
        <defs>
            <clipPath id="clip0_1607_177366">
                <rect width="12" height="11" fill="white" transform="translate(152 110)"></rect>
            </clipPath>
            <clipPath id="clip1_1607_177366">
                <rect width="10" height="10" fill="white" transform="translate(173 131)"></rect>
            </clipPath>
        </defs>
    </svg>
);
